














import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'

@Component
export default class SimpleHeader extends Vue {
  @Prop() icon?: string
}
